<template>
  <v-os-popup title="换新方式" v-model="show" @close="close" container="body">
    <div role="listbox">
      <div
        v-for="(item, index) in renewTypeList"
        :key="index"
        role="option"
        :aria-label="
          item.label + '，' + item.tip + (item.type == info ? '，当前选项已选中' : '，当前选项未选中，点按两次即可选中')
        "
        @click="select(item.type)"
        :class="{ 'custom-dark': customDark }"
        class="renew-item"
      >
        <v-icon name="selected" class="checkbox" v-if="item.type == info"></v-icon>
        <v-icon name="unselected" class="checkbox" v-else></v-icon>
        <div class="renew-main">
          <p class="label">{{ item.label }}</p>
          <p class="tip">{{ item.tip }}</p>
        </div>
      </div>
    </div>
  </v-os-popup>
</template>
<script>
import CONSTANT from '@/views/product/recycle/constant'
export default {
  name: 'RenewTypePopUp',
  props: {
    info: {
      type: [String, Number],
      default: 1
    },
    show: {
      type: Boolean,
      default: false
    },
    customDark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    renewTypeList() {
      return [
        {
          type: CONSTANT.RENEW_TYPE_TOGETHER,
          label: CONSTANT.RENEW_TOGETHER_LABEL,
          tip: CONSTANT.RENEW_TOGETHER_TIP
        },
        { type: CONSTANT.RENEW_TYPE_SINGLE, label: CONSTANT.RENEW_SINGLE_LABEL, tip: CONSTANT.RENEW_SINGLE_TIP }
      ]
    }
  },
  data() {
    return {
      CONSTANT
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    select(renewType) {
      if (renewType == this.info) {
        this.$emit('close')
      } else {
        this.$emit('select', renewType)
        this.$toast('以旧换新换新方式发生变更，回收款及换新补贴发放逻辑将发生变更')
        this.$emit('close')
      }
    }
  },
  created() {},
  mounted() {}
}
</script>
<style lang="scss" scoped>
.listbox {
  margin-top: 3px;
}
.renew-item {
  width: 100%;
  background: #f9f9f9;
  border-radius: 24px;
  margin-bottom: 30px;
  padding: 40px 48px 42px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  &.custom-dark {
    @include bgColor(#f9f9f9, rgba(255, 255, 255, 0.1));
    .label {
      @include fontColor(#000, rgba(255, 255, 255, 0.9));
    }
    .tip {
      @include fontColor(#888888, rgba(255, 255, 255, 0.5));
    }
  }
  &.disabled {
  }
  .label {
    font-size: 42px;
    line-height: 58px;
    @include os-font-weight(42, 50);
    color: #000000;
  }
  .tip {
    margin-top: 16px;
    font-size: 36px;
    line-height: 48px;
    @include os-font-weight(36, 40);
    color: #888888;
  }
  .checkbox {
    width: 54px;
    height: 54px;
    flex-shrink: 0;
    margin-right: 30px;
  }
}
</style>
